exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reglink[data-v-c21bafea]{padding:0 2.5em;height:35px;border-radius:.2em;text-decoration:none;border-width:2px;border-style:solid;color:#fff;display:inline-block;font-family:Open Sans,sans-serif;font-size:10px;font-weight:700;text-transform:uppercase;transition:all .3s ease}.reglink_lime[data-v-c21bafea]{background-color:#45d375;border-color:#45d375}.reglink_lime[data-v-c21bafea]:hover{background-color:#61da8a;border-color:#61da8a;opacity:.8}.reglink_wide[data-v-c21bafea]{width:100%}.reglink_block[data-v-c21bafea]{display:block}.reglink span[data-v-c21bafea]{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:140%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c21bafea","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/regularLink/RegularLink.vue
// module id = f3ad4479a5e559669e66
// module chunks = 5